import { Page } from "@/models/page-models/Page";

export const NewSalesContract: Page = {
  "path": "new-sales-contract",
  "name": "New Quotation",
  "props": {
    "data": {
      "title": "New Quotation",
      "printable": "FALSE",
      "url": "new-sales-contract",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyCustomerContacts",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.contactDetails",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.contact"
                      },
                      "name": "copyCustomerContacts"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyCustomerData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCustomer"
                      },
                      "name": "copyCustomerData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyDefaultCustomerContact",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.billingContact",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedContact"
                      },
                      "name": "copyDefaultCustomerContact"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "updateTermsConditionsFromCustomer",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getUpdatedTermsConditionsFromCustomer",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.termsAndConditions"
                      },
                      "name": "updateTermsConditionsFromCustomer"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "pushCustomerIdToProductForm",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.customer",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.productForm.q.customer"
                      },
                      "name": "pushCustomerIdToProductForm"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getProducts",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/search",
                        "arg2Key": "postData",
                        "arg2Value": "fetchedData.productForm",
                        "arg3Key": "storeInVar",
                        "arg3Value": "fetchedData.products"
                      },
                      "name": "getProducts"
                    },
                    {
                      "executionOrder": 3,
                      "name": "copyFilteredProducts"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "copyVatPercentage",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getVatPercentage",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyVatPercentage"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customer.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedContact",
                  "label": "Select Contact",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyContactData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.contact"
                      },
                      "name": "copyContactData"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.contact",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedProduct",
                  "label": "Select Product",
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredProducts",
                  "itemText": "productLine",
                  "itemValue": "_id",
                  "formula": "fn(CONCAT,{{__item._id}}, ,fn(HELPER_FN,productAlias,{{__item}},true,true))",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyProductDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedProductDetails"
                      },
                      "name": "copyProductDetails"
                    }
                  ]
                },
                {
                  "type": "button",
                  "label": "Add Product",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyPriceBracketFlag",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.selectedProductDetails.allowPriceBracket",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.priceBracketOnly"
                      },
                      "name": "copyPriceBracketFlag"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction":  {
                        "name": "addProduct",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceFn",
                        "arg1Value": "findSelectedProductDetails",
                        "arg2Key": "sourceTransformationFn",
                        "arg2Value": "transformProductForTable",
                        "arg3Key": "destinationVariable",
                        "arg3Value": "formData.items"
                      },
                      "name": "addProduct"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "resetSelectedProduct",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedProduct"
                      },
                      "name": "resetSelectedProduct"
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyFilteredProducts"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(NOT,{{fetchedData.selectedProduct}}),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProductDetails.productState}},'),==,'Expired'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProductDetails.productState}},'),==,'Inactive')))",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "qtItemsTable",
                  "variable": "formData.items",
                  "label": "Products Table",
                  "disabled": "FALSE",
                  "items": "fetchedData.products.data.docs",
                  "printable": false,
                  "variableKey": "product",
                  "itemKey": "_id",
                  "executeOnDelete": [
                    {
                      "executionOrder": 2,
                      "name": "copyFilteredProducts"
                    }
                  ],
                  "priceBracketVariable": "formData.priceBracketOnly"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.deliveryLeadTime",
                  "label": "Lead Time From Order Confirmation",
                  "disabled": "FALSE",
                  "items": "fetchedData.deliveryTime.data.0.data",
                  "itemText": "display",
                  "itemValue": "value"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Terms & Conditions"
                }
              ]
            },
            {
              "name": "offer validity row-5a",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.termsAndConditions.offerValidity",
                  "label": "Offer Validity",
                  "disabled": "FALSE",
                  "printable": false,
                  "minDateFormula": "fn(CONDITIONAL,fn(NOT,{{formData.createdAt}}),{{TODAYS_DATE}},{{formData.createdAt}})",
                  "maxDateFormula": "fn(ADD_DAYS,fn(CONDITIONAL,fn(NOT,{{formData.createdAt}}),{{TODAYS_DATE}},{{formData.createdAt}}),365)"
                },
                {
                  "type": "input",
                  "variable": "formData.termsAndConditions.contractDuration",
                  "label": "Contract Duration",
                  "unit": "days",
                  "disabled": "FALSE",
                  "printable": false
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.termsAndConditions.tolerance",
                  "label": "Tolerance",
                  "unit": "%",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.shippingMode",
                  "label": "Shipping Mode",
                  "disabled": "FALSE",
                  "items": "[\"Land\",\"Sea\",\"Air\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "8 (1)",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.tradeTerms.type",
                  "label": "Trade Terms",
                  "disabled": "TRUE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "formula": "{{__item.en}} ({{__item.type}})"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.deliveryLocations",
                  "label": "Delivery Locations",
                  "disabled": "FALSE",
                  "items": "fetchedData.selectedCustomer.deliveryAddresses",
                  "validationKey": "deliveryLocations",
                  "itemText": "ref",
                  "itemValue": "ref",
                  "required": true,
                  "multiple": true
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.termsAndConditions.paymentTerms.type",
                  "label": "Payment Terms",
                  "disabled": "TRUE",
                  "items": "fetchedData.paymentTermOptions.data.0.data",
                  "itemText": "en",
                  "itemValue": "alias",
                  "formula": "{{__item.alias}} ({{__item.en}})"
                }
              ]
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Submit Draft QT",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "updateItemsArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.items",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.items",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getTransformedContractItem"
                      },
                      "name": "updateItemsArray"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "createSalesContract",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/insert",
                        "arg2Key": "storeResponse",
                        "arg2Value": "TRUE",
                        "arg3Key": "serviceConfig",
                        "arg3Value": "{\"service\":\"PRICE_CHANGE_REQUEST\",\"args\":[\"formData.items\",\"fetchedData.products.data.docs\", \"fetchedData.orders\"],\"destinationKey\":\"formData.items\"}"
                      },
                      "name": "createSalesContract"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "redirectToSalesContract",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/edit-sales-contract/{{__response.data._id}}"
                      },
                      "name": "redirectToSalesContract",
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,-1)"
                    }
                  ],
                  "disabled": "fn(NOT,fn(LENGTH,{{formData.items}}))",
                  "showIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Draft'),{{formData.items}},product,{{fetchedData.products.data.docs}},_id),==,0)",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "13",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save As Draft QT",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDraftFlag",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDraftFlag",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copyDraftFlag"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "updateItemsArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.items",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.items",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getTransformedContractItem"
                      },
                      "name": "updateItemsArray"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "createSalesContract",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/insert",
                        "arg2Key": "storeResponse",
                        "arg2Value": "TRUE",
                        "arg3Key": "serviceConfig",
                        "arg3Value": "{\"service\":\"PRICE_CHANGE_REQUEST\",\"args\":[\"formData.items\",\"fetchedData.products.data.docs\", \"fetchedData.orders\"],\"destinationKey\":\"formData.items\"}"
                      },
                      "name": "createSalesContract"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "redirectToSalesContract",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/edit-sales-contract/{{__response.data._id}}"
                      },
                      "name": "redirectToSalesContract",
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,-1)"
                    }
                  ],
                  "disabled": "fn(NOT,fn(LENGTH,{{formData.items}}))",
                  "showIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Draft'),{{formData.items}},product,{{fetchedData.products.data.docs}},_id),>,0)",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getDeliveryLeadTimes",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=leadTime",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.deliveryTime"
        },
        "name": "getDeliveryLeadTimes"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPaymentTerms",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=payment-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.paymentTermOptions"
        },
        "name": "getPaymentTerms"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "initialiseTerms&Conditions",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "createInitalTerms",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.termsAndConditions"
        },
        "name": "initialiseTerms&Conditions"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "addDefaultSalesContractType",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultSalesContractType",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "addDefaultSalesContractType"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyCustomerId",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "__query.customer",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.customer",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Number"
        },
        "name": "copyCustomerId",
        "executeIf": "fn(LOGICAL,{{__query.customer}},>,0)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductsForm"
      }
    ],
    "functions": [
      {
        "name": "findSelectedProductDetails",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.products.data.docs",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedProduct"
      },
      {
        "name": "transformProductForTable",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "{{__selectedObject._id}}",
          "productPrice": "{}"
        },
        "useFormula": true
      },
      {
        "name": "createInitalTerms",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "deliveryLeadTime": "30",
          "tolerance": "10",
          "shippingMode": "Land",
          "tradeTerms": "{}",
          "paymentTerms": "{}",
          "offerValidity": "fn(ADD_DAYS,{{TODAYS_DATE}},15)",
          "contractDuration": "90"
        },
        "useFormula": true
      },
      {
        "name": "getUpdatedTermsConditionsFromCustomer",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "contractDuration": "{{formData.termsAndConditions.contractDuration}}",
          "deliveryLeadTime": "{{formData.termsAndConditions.deliveryLeadTime}}",
          "offerValidity": "{{formData.termsAndConditions.offerValidity}}",
          "paymentTerms": "{{fetchedData.selectedCustomer.termsAndConditions.paymentTerms}}",
          "shippingMode": "{{formData.termsAndConditions.shippingMode}}",
          "tolerance": "{{formData.termsAndConditions.tolerance}}",
          "tradeTerms": "{{fetchedData.selectedCustomer.termsAndConditions.tradeTerms}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultSalesContractType",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "Sales Contract"
        },
        "useFormula": true
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{fetchedData.selectedCustomer.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "getFilteredProducts",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "filteredProducts": "fn(HELPER_FN,filterProducts,{{fetchedData.products.data.docs}},{{formData.items}})"
        },
        "useFormula": true
      },
      {
        "name": "copyFilteredProducts",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getFilteredProducts",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getSelectedItem",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.products.data.docs",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedOrder.product"
      },
      {
        "name": "getSelectedOrder",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "formData.items",
        "arg2Key": "searchKey",
        "arg2Value": "product",
        "arg3Key": "searchValue",
        "arg3Value": "__selectedObject._id"
      },
      {
        "name": "getTransformedContractItem",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "{{__selectedObject.product}}",
          "productPrice": "{{__selectedObject.productPrice}}",
          "totalQuantity": "{{__selectedObject.totalQuantity}}",
          "totalFOC": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.totalFOC}},>,0),{{__selectedObject.totalFOC}},0)"
        },
        "useFormula": true
      },
      {
        "name": "getDraftFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "isDraft": "true"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": ["Draft", "Pending", "Open" ]
          },
          "page": 1
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Open Prospect", "Open Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 88
}